export default () => {
  /**
   * add a class to the header when scrolled
   */
  let headerElement     = document.querySelector('.mainHeader');
  let headerScrollClass = 'scrolled';

  //define scroll parameters
  let maxScrollPosition = 5;

  //check scroll state by scrolling
  window.addEventListener('scroll', checkScrollState);

  //initial scroll state
  checkScrollState();

  /*
   * add/remove class to/from header if scroll state should be active/disabled
   */
  function checkScrollState() {
    //define current scroll position
    let currentScrollPosition = window.pageYOffset;

    if (currentScrollPosition > maxScrollPosition) {
      //add class to header
      headerElement.classList.add(headerScrollClass);
    } else {
      //remove class to header
      headerElement.classList.remove(headerScrollClass);
    }
  }
}
